'use client'

import { useEffect, useState } from 'react'

import { useToast } from '@/components/ui'
import { useWebSocket } from '@/hooks/useWebSocket'
import { listenAppAlert, offListenAppAlert } from '@/services/socket'

const AppAlert = () => {
  const { toast } = useToast()
  const { socket } = useWebSocket('/users-socket')
  const [alertMessage, setAlertMessage] = useState<string | null>(null)

  useEffect(() => {
    if (!socket) return
    listenAppAlert(socket, setAlertMessage)
    return () => offListenAppAlert(socket)
  }, [socket])

  useEffect(() => {
    if (!alertMessage) return
    toast({
      title: 'Notificação do sistema',
      description: alertMessage,
      variant: 'default',
      duration: 5000,
    })
    setAlertMessage(null)
  }, [alertMessage, toast])

  return null
}

AppAlert.displayName = 'AppAlert'

export { AppAlert }
